import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import { TextInput } from "@ebsco-ui/ebsco-ui";
import cn from "classnames";

import "./text-input-field.scss";

const TextInputField = ({ id, name, validationSchema, className, ...rest }) => {
  const validateWithSchema = value => {
    if (validationSchema) {
      try {
        validationSchema.validateSync(value);
      } catch (error) {
        return error.message;
      }
    }
  };

  const errorToDisplay = meta => {
    if (meta.error && meta.submitFailed) return meta.error;
    if (
      meta.submitError &&
      meta.submitError.length > 0 &&
      !meta.dirtySinceLastSubmit
    )
      return meta.submitError[0];
    return "";
  };

  return (
    <Field id={id} name={name} validate={validateWithSchema}>
      {({ input, meta }) => (
        <TextInput
          className={cn("text-input", className)}
          id={id}
          error={errorToDisplay(meta)}
          {...input}
          {...rest}
        />
      )}
    </Field>
  );
};

TextInputField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  validationSchema: PropTypes.object
};

export { TextInputField };
export default TextInputField;
